export * from "./core";

import "./en-US";
import "./zh-TW";
import "./ja-JP";

import "@/assets/i18n";
/*
 * File: index.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified:
 * Modified By:
 * -----
 */
